import { Filters } from '../../../common/components/CloudAndProductFilters/CloudAndProductFilters'
import { useFlyOutProductsBasedOnSelectedCloud } from '../../../common/utils/hooks/useFlyOutProductsBasedOnSelectedCloud'
import {
  PartnerType,
  useAccountId,
  useCurrentCloudProvider,
  useUserType,
} from '@labrav/common'
import { Link, useParams } from 'react-router-dom'
import React, { useEffect } from 'react'
import { ResaleAuthorizationsList } from '../ResaleAuthorizationsList'
import { useStyles } from './ResaleAuthorizationsWrapperUI.styles'
import { useDispatch } from '../../../store'
import { isEmpty } from 'lodash'
import { getProducts } from '../../../modules/productsListing/action'
import { Button } from '@labrav/react-components'
import { FlyoutFunction } from '../../../modules/productListingFilter/types'
import { clearResaleAuthorizations } from '../../modules/resaleAuthorizations'
import type { ResaleAuthorizationsProps } from './types'

export type { ResaleAuthorizationsProps } from './types'

const ResaleAuthorizationsWrapperUI: React.FC<ResaleAuthorizationsProps> = ({
  externalBaseURL,
  search,
  crmOpportunityId,
}) => {
  const { classes } = useStyles()
  const dispatch = useDispatch()
  const isAdmin = useUserType() === PartnerType.Admin
  //TO DO: https://ibexlabs.atlassian.net/browse/LT-3594 Remove this useEffect and its processing
  const { partner_id: accountIdFromParams } = useParams<{
    partner_id?: string
  }>()
  const accountId =
    useAccountId({ product: 'flyout' }) || accountIdFromParams || ''
  const selectedCloudTypeProductListing = useCurrentCloudProvider()
  const { products, selectedProduct: productId } =
    useFlyOutProductsBasedOnSelectedCloud()

  const getProductsAndClearAuthorization = async () => {
    await dispatch(clearResaleAuthorizations())
    await dispatch(getProducts(accountId, selectedCloudTypeProductListing))
  }
  useEffect(() => {
    if (!isEmpty(accountId) && !externalBaseURL) {
      if (isEmpty(products)) {
        getProductsAndClearAuthorization()
      }
    }
  }, [accountId, selectedCloudTypeProductListing])

  return (
    <div
      className={
        isAdmin ? classes.adminContainer : classes.labraResaleContainer
      }
    >
      <Filters
        functionType={FlyoutFunction.RESALE_AUTHORIZATIONS}
        externalBaseURL={externalBaseURL}
        search={search}
      >
        <div className={classes.createOfferBtn}>
          {!isAdmin && productId !== '' ? (
            <Link
              to={{
                pathname: `${
                  externalBaseURL || '/flyout/products-listing'
                }/${productId}/resale-authorizations/edit`,
                search,
              }}
              className={classes.createOfferLink}
              data-testid={'createResaleAuthorization'}
            >
              <Button variant="contained" styleType="primary">
                Create a new resale authorization
              </Button>
            </Link>
          ) : null}
        </div>
      </Filters>
      <ResaleAuthorizationsList
        crmOpportunityId={crmOpportunityId}
        externalBaseURL={externalBaseURL}
        search={search}
      />
    </div>
  )
}

export default ResaleAuthorizationsWrapperUI
export { ResaleAuthorizationsWrapperUI }
